import React, {
  Suspense,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import {
  EmployeeCycleReview,
  GetEmployeeAppraisals,
  SaveKraScore,
  SaveManagerAppraisal,
  sendBackAssessment,
  SubmitManagerAppraisal,
} from "./PMSService";
import { TostMsg } from "../../../App";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";

export const AssessmentReview = () => {
  const [showSendBackModal, setShowSendBackModal] = useState(false);
  const [showSubmitModal, setShowSubmitModal] = useState(false);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [appraisal, setAppraisal] = useState(null);

  const [ratings, setRatings] = useState({});
  const [kraComments, setKraComments] = useState({});
  const [questionScores, setQuestionScores] = useState({});
  const [questionComments, setQuestionComments] = useState({});
  const [overallComment, setOverallComment] = useState("");

  const [sendBackReason, setSendBackReason] = useState("");
  const { guid } = useParams();
  const { history } = useHistory();

  const { toster } = useContext(TostMsg);
  const location = useLocation();
  const [mode, SetMode] = useState("");

  /* ----------------------------------------------------------
     GET APPRAISAL DETAIL
  ---------------------------------------------------------- */

  useEffect(() => {
    getAppraisalDetail();

    const mode = location.pathname.split("/")[2];
    SetMode(mode);

    console.log(mode); // "View"
  }, [guid]);

  const getAppraisalDetail = async () => {
    try {
      setLoading(true);
      // setError("");
      const params = {
        Guid: guid,
      };

      /*
       * Change this URL according to your actual GET API.
       */
      const response = await GetEmployeeAppraisals(params);

      console.log("Appraisal detail response:", response?.Data);

      const apiData = response?.Data;

      setAppraisal(apiData);

      /*
       * Existing overall comment
       */
      setOverallComment(apiData?.HrComment || "");

      /*
       * Existing KRA ratings/comments
       */
      //       const kraList = useMemo(() => {
      //    return appraisal?.Kras || [];
      // }, [appraisal]);

      const ratingState = {};
      const commentState = {};

      const apiKras = Array.isArray(apiData?.Kras) ? apiData.Kras : [];

      apiKras.forEach((kra) => {
        const key = String(kra.KraSnapshotId);

        ratingState[key] =
          kra.ManagerRating == null ? 0 : Number(kra.ManagerRating);

        commentState[key] = kra.ManagerComment ?? "";
      });

      setRatings(ratingState);
      setKraComments(commentState);

      /*
       * Existing question scores/comments
       */
      const questions =
        apiData?.Questions ||
        apiData?.OpenFormQuestions ||
        apiData?.CriteriaAnswers ||
        apiData?.OpenQuestions ||
        [];

      const questionScoreState = {};
      const questionCommentState = {};

      questions.forEach((question, index) => {
        const key = question?.QuestionId ?? question?.Id ?? `question-${index}`;

        questionScoreState[key] = Number(
          question?.ManagerScore ??
            question?.ReviewerScore ??
            question?.Score ??
            question?.Rating ??
            0,
        );

        questionCommentState[key] =
          question?.ManagerAssessment ??
          question?.ReviewerComment ??
          question?.Assessment ??
          question?.Comment ??
          "";

        if (!key) return;

        // IMPORTANT: API is returning EffectiveScore
        questionScoreState[key] = Number(question?.EffectiveScore ?? 0);

        questionCommentState[key] = question?.ManagerComment ?? "";
      });

      setQuestionScores(questionScoreState);
      setQuestionComments(questionCommentState);
    } catch (err) {
      console.error("Get appraisal detail error:", err);

      // setError(
      //   err?.response?.data?.Message ||
      //     err?.response?.data?.message ||
      //     "Failed to load appraisal details.",
      // );
    } finally {
      setLoading(false);
    }
  };

  const [submitting, setSubmitting] = useState(false);

  // const handleManagerSubmit = async () => {
  //   console.log("========== SUBMIT CLICKED ==========");

  //   if (!appraisal?.AppraisalId) {
  //     console.error("Appraisal ID is missing:", appraisal);
  //     toster?.current?.error("Appraisal ID is missing.");
  //     return;
  //   }

  //   setLoading(true);
  //   const payload = {
  //     KraRatings: kraList.map((kra, index) => {
  //       const kraSnapshotId =
  //         kra?.KraSnapshotId ?? kra?.SnapshotId ?? kra?.Id ?? 0;

  //       const kraId = getKraId(kra, index);

  //       return {
  //         KraSnapshotId: Number(kraSnapshotId),
  //         Rating: Number(ratings[kraId] || 0),
  //         Comment: kraComments[kraId] || "",
  //       };
  //     }),

  //     CriteriaScores: questionList.map((question, index) => {
  //       const questionId = getQuestionId(question, index);

  //       return {
  //         QuestionId: Number(question?.QuestionId ?? question?.Id ?? 0),
  //         Score: Number(questionScores[questionId] || 0),
  //         Comment: questionComments[questionId] || "",
  //       };
  //     }),

  //     OverallComment: overallComment || "",
  //   };

  //   try {
  //     setSubmitting(true);

  //     const response = await SubmitManagerAppraisal(
  //       Number(appraisal.AppraisalId),
  //       payload,
  //     );

  //     if (response?.StatusCode === 2000) {
  //       toster?.current?.success(
  //         response?.Message ||
  //           response?.message ||
  //           "Manager review submitted successfully.",
  //       );

  //       await getAppraisalDetail();
  //       setShowSubmitModal(false);
  //     }

  //     setLoading(false);
  //   } catch (error) {
  //     toster?.current?.error(
  //       error?.response?.data?.Message ||
  //         error?.response?.data?.message ||
  //         "Failed to submit manager review.",
  //     );
  //   } finally {
  //     setSubmitting(false);
  //     setLoading(false);
  //   }
  // };

  const handleManagerSubmit = async () => {
    if (!appraisal?.AppraisalId) {
      toster?.current?.error("Appraisal ID is missing.");
      return;
    }

    // Validate all KRA ratings before making API calls.
    const missingRating = kraList.find((kra, index) => {
      const key = String(getKraId(kra, index));
      const rating = Number(ratings[key] || 0);

      return !Number.isInteger(rating) || rating < 1 || rating > 5;
    });

    if (missingRating) {
      toster?.current?.error(
        `Please select a rating from 1 to 5 for ${getKraTitle(missingRating)}.`,
      );
      return;
    }

    setSubmitting(true);
    setLoading(true);

    try {
      // Step 1: Save each KRA score through the individual KRA API.
      // for (let index = 0; index < kraList.length; index++) {
      //   const kra = kraList[index];

        // const saved = await handleSaveKraScore(kra, false);

        // if (!saved) {
        //   // Stop if any KRA fails to save.
        //   return;
        // }
      // }

      // Step 2: Prepare the complete manager review payload.
      const payload = {
        KraRatings: kraList.map((kra, index) => {
          const kraSnapshotId = getKraId(kra, index);
          const key = String(kraSnapshotId);

          return {
            KraSnapshotId: Number(kraSnapshotId),
            Rating: Number(ratings[key]),
            Comment: kraComments[key] || "",
          };
        }),

        CriteriaScores: questionList.map((question, index) => {
          const questionId = getQuestionId(question, index);

          return {
            QuestionId: Number(question?.QuestionId ?? question?.Id ?? 0),
            Score: Number(questionScores[questionId] || 0),
            Comment: questionComments[questionId] || "",
          };
        }),

        OverallComment: overallComment || "",
      };

      // Step 3: Submit the manager appraisal.
      const response = await SubmitManagerAppraisal(
        Number(appraisal.AppraisalId),
        payload,
      );

      const result = response?.data ?? response;

      const statusCode = result?.statusCode ?? result?.StatusCode;

      if (
        statusCode === 200 ||
        statusCode === 2000 ||
        result?.status === "Success"
      ) {
        toster?.current?.success(
          result?.message ||
            result?.Message ||
            "Manager review submitted successfully.",
        );

        setShowSubmitModal(false);
        await getAppraisalDetail();
      } else {
        toster?.current?.error(
          result?.message ||
            result?.Message ||
            "Failed to submit manager review.",
        );
      }
    } catch (error) {
      toster?.current?.error(
        error?.response?.data?.message ||
          error?.response?.data?.Message ||
          "Failed to submit manager review.",
      );
    } finally {
      setSubmitting(false);
      setLoading(false);
    }
  };

  /* ----------------------------------------------------------
     DATA HELPERS
  ---------------------------------------------------------- */

  const employeeName = appraisal?.EmployeeName || "-";

  const designation = appraisal?.Designation || "-";

  const department = appraisal?.Department || "-";

  const cycleTitle = appraisal?.CycleTitle || "Primary Appraisal";

  const reviewerName = appraisal?.FirstReviewerName || "-";

  const reviewerRole = "Manager";

  const secondReviewerName = appraisal?.SecondReviewerName || "-";

  const normalizationActorName = appraisal?.NormalizationActorName || "-";

  const selfSubmittedDate = appraisal?.CurrentStageId > 1;
  // appraisal?.AcknowledgedOn &&
  // !String(appraisal.AcknowledgedOn).startsWith("0001")
  //   ? appraisal.AcknowledgedOn
  //   : null;

  const deadline = appraisal?.ManagerReviewDeadline || null;

  const computedScore = appraisal?.ComputedScore ?? 0;

  const kraScore = appraisal?.KraScore ?? 0;

  const criteriaScore = appraisal?.CriteriaScore ?? 0;

  const kraWeight = appraisal?.KraSectionWeightage ?? 60;

  const criteriaWeight = appraisal?.CriteriaSectionWeightage ?? 40;

  const promotionRecommended = appraisal?.IsPromotionRecommended ?? false;

  const appraisalId = appraisal?.AppraisalId ?? 0;

  const kraList = useMemo(() => {
    return Array.isArray(appraisal?.Kras) ? appraisal.Kras : [];
  }, [appraisal]);

  const questionList = useMemo(() => {
    return Array.isArray(appraisal?.Questions) ? appraisal.Questions : [];
  }, [appraisal]);

  const timeline = appraisal?.Timeline || appraisal?.timeline || [];

  const auditTrail = useMemo(() => {
    return Array.isArray(appraisal?.History) ? appraisal.History : [];
  }, [appraisal]);

  /* ----------------------------------------------------------
     FORMATTERS
  ---------------------------------------------------------- */

  const formatDate = (value) => {
    if (!value) return "-";

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return value;
    }

    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  const formatDateTime = (value) => {
    if (!value) return "-";

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return value;
    }

    return (
      date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      }) +
      " · " +
      date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      })
    );
  };

  const getInitials = (name) => {
    if (!name) return "--";

    return name
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((item) => item.charAt(0).toUpperCase())
      .join("");
  };

  /* ----------------------------------------------------------
     RATING
  ---------------------------------------------------------- */

  const selectRating = (key, value) => {
    setRatings((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const ratingButton = (id, value, type, selectedValue) => {
    const isSelected = Number(selectedValue) === Number(value);

    return (
      <button
        key={`${type}-${id}-${value}`}
        type="button"
        className={`btn-og ${
          isSelected ? "btn-og-primary" : "btn-og-secondary"
        } btn-og-sm ar-rating-btn ${
          isSelected ? "ar-rating-btn-selected" : ""
        }`}
        disabled={isEmployeeView || savingKraId === Number(id)}
        onClick={() => {
          if (type === "kra") {
            setRatings((prev) => ({
              ...prev,
              [String(id)]: value,
            }));
          } else if (type === "question") {
            setQuestionScores((prev) => ({
              ...prev,
              [id]: value,
            }));
          }
        }}
      >
        {value}
      </button>
    );
  };

  /* ----------------------------------------------------------
     KRA HELPERS
  ---------------------------------------------------------- */

  const getKraId = (kra) => kra?.KraSnapshotId;

  const getKraTitle = (kra) => kra?.KraTitle || "KRA";

  // const getKraDescription = (kra) => kra?.kraDescription || "";

  // const getKraWeight = (kra) => kra?.weightage ?? kra?.weight ?? 0;

  const getKpiList = (kra) => (Array.isArray(kra?.Kpis) ? kra.Kpis : []);

  const getKpiTitle = (kpi) => kpi?.KpiDescription || "KPI";

  const getKpiProgress = (kpi) => Number(kpi?.CompletionPct ?? 0);

  const getKpiNarrative = (kpi) => kpi?.EmployeeNarrative || "";

  const getKpiId = (kpi) => kpi?.KpiSnapshotId;

  const [savingKraId, setSavingKraId] = useState(null);

  // const handleSaveKraScore = async (kra, refresh = true) => {
  //   const kraSnapshotId = Number(
  //     kra?.KraSnapshotId ?? kra?.kraSnapshotId ?? kra?.SnapshotId ?? kra?.Id,
  //   );

  //   const currentAppraisalId = Number(appraisal?.AppraisalId);
  //   const key = String(kraSnapshotId);
  //   const rating = Number(ratings[key] || 0);
  //   const comment = kraComments[key] || "";

  //   if (!currentAppraisalId || !kraSnapshotId) {
  //     toster?.current?.error("Appraisal ID or KRA ID is missing.");
  //     return false;
  //   }

  //   if (!Number.isInteger(rating) || rating < 1 || rating > 5) {
  //     toster?.current?.error(
  //       `Please select a rating from 1 to 5 for ${getKraTitle(kra)}.`,
  //     );
  //     return false;
  //   }

  //   try {
  //     setSavingKraId(kraSnapshotId);

  //     const response = await SaveKraScore(currentAppraisalId, kraSnapshotId, {
  //       rating,
  //       comment,
  //     });

  //     const result = response?.data ?? response;

  //     const statusCode = result?.statusCode ?? result?.StatusCode;

  //     const success =
  //       statusCode === 200 ||
  //       statusCode === 2000 ||
  //       result?.status === "Success";

  //     if (!success) {
  //       toster?.current?.error(
  //         result?.message || result?.Message || "Failed to save KRA score.",
  //       );
  //       return false;
  //     }

  //     if (refresh) {
  //       toster?.current?.success("KRA score saved successfully.");
  //       await getAppraisalDetail();
  //     }

  //     return true;
  //   } catch (error) {
  //     toster?.current?.error(
  //       error?.response?.data?.message ||
  //         error?.response?.data?.Message ||
  //         "Failed to save KRA score.",
  //     );

  //     return false;
  //   } finally {
  //     setSavingKraId(null);
  //   }
  // };

  /* ----------------------------------------------------------
     QUESTION HELPERS
  ---------------------------------------------------------- */

  const getQuestionId = (question, index) =>
    question?.QuestionId ?? question?.Id ?? `question-${index}`;

  const getQuestionCategory = (question) =>
    question?.Category ||
    question?.SectionName ||
    question?.CategoryName ||
    "Question";

  const getQuestionWeight = (question) =>
    question?.Weightage ?? question?.Weight ?? 0;

  const getQuestionText = (question) =>
    question?.Question ||
    question?.QuestionText ||
    question?.Description ||
    question?.Title ||
    "";

  const getEmployeeAnswer = (question) =>
    question?.EmployeeAnswer || question?.Answer || question?.Response || "";

  const getManagerAnswer = (question) => question?.ManagerComment || "";

  const getSkipLevelAnswer = (question) => question?.SkipLevelComment || "";

  const SkipLevelScore = (question) => question?.SkipLevelScore || 0;

  /* ----------------------------------------------------------
     PROGRESS
  ---------------------------------------------------------- */

  const kraRatedCount = kraList.filter((kra, index) => {
    const key = getKraId(kra, index);

    return Number(ratings[key] || 0) > 0;
  }).length;

  const questionScoredCount = questionList.filter((question, index) => {
    const key = getQuestionId(question, index);

    return Number(questionScores[key] || 0) > 0;
  }).length;

  const kraProgress = kraList.length
    ? (kraRatedCount / kraList.length) * 100
    : 0;

  const questionProgress = questionList.length
    ? (questionScoredCount / questionList.length) * 100
    : 0;

  /* ----------------------------------------------------------
     COMPUTED SCORE
  ---------------------------------------------------------- */

  //   const computedScore =
  //     appraisal?.ComputedScore ??
  //     appraisal?.WeightedComputedScore ??
  //     appraisal?.FinalScore ??
  //     0;

  //   const kraWeight =
  //     appraisal?.KraSectionWeightage ??
  //     appraisal?.KRASectionWeightage ??
  //     appraisal?.KraWeightage ??
  //     60;

  //   const criteriaWeight =
  //     appraisal?.CriteriaSectionWeightage ?? appraisal?.OpenFormWeightage ?? 40;

  /* ----------------------------------------------------------
     SAVE DRAFT
     -----------------------------------------------
     No Save Draft endpoint was provided in the screenshot.
     Keep this handler ready for the actual API.
  ---------------------------------------------------------- */

  const handleSaveDraft = async () => {
    if (!appraisal?.AppraisalId) {
      toster?.current?.error("Appraisal ID is missing.");
      return;
    }

    try {
      setSaving(true);

      // ---------------------------------------------
      // Build exact API payload
      // ---------------------------------------------
      const payload = {
        KraRatings: kraList.map((kra, index) => {
          const kraId = getKraId(kra, index);

          return {
            KraSnapshotId: Number(
              kra?.KraSnapshotId ?? kra?.SnapshotId ?? kra?.Id ?? 0,
            ),

            Rating: Number(ratings[kraId] || 0),

            Comment: kraComments[kraId] || "",
          };
        }),

        CriteriaScores: questionList.map((question, index) => {
          const questionId = getQuestionId(question, index);

          return {
            QuestionId: Number(question?.QuestionId ?? question?.Id ?? 0),

            Score: Number(questionScores[questionId] || 0),

            Comment: questionComments[questionId] || "",
          };
        }),

        OverallComment: overallComment || "",
      };

      console.log("========== SAVE DRAFT ==========");

      console.log("Appraisal ID:", appraisal.AppraisalId);

      console.log("Save Draft Payload:", payload);

      // ---------------------------------------------
      // Call Save Draft API
      // ---------------------------------------------
      const response = await SaveManagerAppraisal(
        Number(appraisal.AppraisalId),
        payload,
      );

      // ---------------------------------------------
      // Success
      // ---------------------------------------------
      if (response?.StatusCode === 2000) {
        toster?.current?.success(
          response?.Message ||
            response?.message ||
            "Manager review draft saved successfully.",
        );
        await getAppraisalDetail();
      }

      // ---------------------------------------------
      // Refresh appraisal
      // ---------------------------------------------
    } catch (error) {
      console.error("========== SAVE DRAFT API ERROR ==========");

      console.error(error);
      console.error("Response:", error?.response);
      console.error("Response Data:", error?.response?.data);

      toster?.current?.error(
        error?.response?.data?.Message ||
          error?.response?.data?.message ||
          "Failed to save review draft.",
      );
    } finally {
      setSaving(false);
    }
  };

  /* ----------------------------------------------------------
     SEND BACK
  ---------------------------------------------------------- */

  const handleSendBack = async () => {
    if (!sendBackReason.trim()) {
      alert("Please enter a reason.");
      return;
    }

    try {
      const params = {
        SendBackToStageId: 1,
        Reason: sendBackReason,
      };

      const response = await sendBackAssessment(params, appraisalId);

      if (response?.StatusCode === 2000) {
        toster.current.success("Assessment send back to employee successfully");
        history.push("/Assessment/Cycles");
      }
    } catch (error) {}

    setShowSendBackModal(false);
  };

  /* ----------------------------------------------------------
     SUBMIT REVIEW
  ---------------------------------------------------------- */
  const isEmployeeView = mode.toLowerCase() === "view";
  const canRateKra = !isEmployeeView && appraisal?.CurrentStageId === 2;

  const handleSubmitReview = async () => {
    /*
     * Submit API was not provided.
     * Keep payload ready for the actual endpoint.
     */

    const payload = {
      //   CycleId: Number(cycleId),
      //   EmpId: Number(empId),

      KRAResponses: kraList.map((kra, index) => {
        const key = getKraId(kra, index);

        return {
          KraId: Number(kra?.KraId ?? kra?.KRAId ?? kra?.Id ?? 0),
          Rating: Number(ratings[key] || 0),
          Comment: kraComments[key] || "",
        };
      }),

      CriteriaAnswers: questionList.map((question, index) => {
        const key = getQuestionId(question, index);

        return {
          QuestionId: Number(question?.QuestionId ?? question?.Id ?? 0),
          Score: Number(questionScores[key] || 0),
          Assessment: questionComments[key] || "",
        };
      }),

      OverallReviewComment: overallComment,
    };

    console.log("Submit Review payload:", payload);

    alert("Submit payload prepared. Submit Review API endpoint is required.");

    setShowSubmitModal(false);
  };

  /* ----------------------------------------------------------
     LOADING
  ---------------------------------------------------------- */

  //   if (loading) {
  //     return (
  //       <div className="container-fluid">
  //         <div className="row g-3 assessment-module">
  //           <div className="og-main">
  //             <div className="og-card">Loading appraisal review...</div>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   }

  /* ----------------------------------------------------------
     ERROR
  ---------------------------------------------------------- */

  //   if (error) {
  //     return (
  //       <div className="container-fluid">
  //         <div className="row g-3 assessment-module">
  //           <div className="og-main">
  //             <div className="og-card">
  //               <div
  //                 style={{
  //                   color: "#e53e3e",
  //                   fontWeight: 600,
  //                 }}
  //               >
  //                 {error}
  //               </div>

  //               <button
  //                 type="button"
  //                 className="btn-og btn-og-secondary"
  //                 style={{ marginTop: 12 }}
  //                 onClick={getAppraisalDetail}
  //               >
  //                 Retry
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   }

  return (
    <div className="container-fluid">
      {/* Internal CSS */}

      <div className="row g-3 assessment-module">
        <div className="og-main">
          {/* =====================================================
              PAGE HEADER
          ===================================================== */}

          <div className="og-page-header">
            <div>
              <div className="og-breadcrumb">
                <a className="ar-breadcrumb-link">My Dashboard</a> ›{" "}
                <a className="ar-breadcrumb-link">{cycleTitle}</a> ›{" "}
                {employeeName}
              </div>

              <div className="og-page-title">Manager Review</div>

              <div className="og-page-sub">
                Reviewing: <strong>{employeeName}</strong> · {designation} ·{" "}
                {department}
              </div>
            </div>

            <div className="ar-header-actions">
              {appraisal?.CurrentStageId === 2 && (
                <button
                  type="button"
                  className="btn-og btn-og-danger btn-sm"
                  onClick={() => setShowSendBackModal(true)}
                >
                  <i className="fa fa-rotate-left"></i> Send Back
                </button>
              )}

              {appraisal?.CurrentStageId <= 2 && (
                <>
                  <button
                    type="button"
                    className="btn btn-sm btn-gray"
                    onClick={handleSaveDraft}
                    disabled={saving}
                  >
                    {saving ? "Saving..." : "Save Draft"}
                  </button>

                  <button
                    type="button"
                    className="btn-og btn-og-primary btn-sm"
                    onClick={() => setShowSubmitModal(true)}
                  >
                    <i className="fa fa-check"></i> Submit Review
                  </button>
                </>
              )}
              {appraisal?.CurrentStageId === 1 && (
                <button type="button" className="btn-og btn-og-primary btn-sm">
                  <i className="fa fa-check"></i> Send Reminder
                </button>
              )}
            </div>
          </div>

          {/* =====================================================
              MAIN + SIDEBAR
          ===================================================== */}

          <div className="ar-layout">
            <div>
              {/* =================================================
                  REVIEWER CONTEXT
              ================================================= */}

              <div className="og-card">
                <div className="ar-ctx-row">
                  {/* YOU ARE */}

                  <div className="ar-flex1">
                    <div className="ar-label-caps">You Are</div>

                    <div className="og-emp-cell">
                      <div className="og-emp-av ar-emp-av">
                        {getInitials(reviewerName)}
                      </div>

                      <div className="ar-ctx-name">
                        {reviewerName} — {reviewerRole}
                      </div>
                    </div>
                  </div>

                  {/* SELF SUBMITTED */}

                  <div className="ar-flex1">
                    <div className="ar-label-caps">Self Submitted</div>

                    <div
                      className={`ar-ctx-value ${
                        selfSubmittedDate ? "ar-submitted" : "ar-not-submitted"
                      }`}
                    >
                      <i
                        className={
                          selfSubmittedDate
                            ? "fa fa-check-circle"
                            : "fa fa-circle"
                        }
                      ></i>{" "}
                      {selfSubmittedDate
                        ? formatDateTime(selfSubmittedDate)
                        : "Not submitted"}
                    </div>
                  </div>

                  {/* YOUR DEADLINE */}

                  <div className="ar-flex1">
                    <div className="ar-label-caps">Your Deadline</div>

                    <div className="ar-deadline">
                      <i className="fa fa-clock"></i> {deadline || "-"}
                    </div>
                  </div>
                </div>
              </div>

              {/* =================================================
                  KRA ASSESSMENT
              ================================================= */}

              <div className="og-card ar-mb14">
                <div className="og-section-hd">
                  <div className="og-section-num">A</div>

                  <div className="og-section-title">KRA Assessment</div>

                  <div className="og-section-wt">
                    {kraWeight}% of final score
                  </div>
                </div>

                <div className="ar-info-banner">
                  <i className="fa fa-circle-info ar-info-icon" />{" "}
                  {isEmployeeView
                    ? "View your KRAs and KPI progress here. Update your progress and narrative in the Goals section."
                    : "Review the employee's KPI progress and narrative, then provide a rating for each KRA."}
                </div>

                {/* DYNAMIC KRA LIST */}

                {kraList.length === 0 ? (
                  <div className="og-kra-card ar-mb12">
                    No KRA data available.
                  </div>
                ) : (
                  kraList.map((kra, kraIndex) => {
                    const kraId = getKraId(kra, kraIndex);
                    const kpis = getKpiList(kra);

                    return (
                      <div
                        className={`og-kra-card ${
                          kraIndex === kraList.length - 1 ? "ar-mb0" : "ar-mb12"
                        }`}
                        key={kraId}
                      >
                        <div className="og-kra-header">
                          <div>
                            <div className="og-kra-title">
                              {getKraTitle(kra)}
                            </div>

                            {/* {getKraDescription(kra) && (
                              <p
                                style={{ whiteSpace: "pre-wrap", marginTop: 6 }}
                              >
                                {getKraDescription(kra)}
                              </p>
                            )} */}
                          </div>

                          {/* {getKraWeight(kra) > 0 && (
                            <span className="og-section-wt">
                              {getKraWeight(kra)}%
                            </span>
                          )} */}
                        </div>

                        <div className="ar-kpi-box">
                          <div className="ar-kpi-box-title">
                            Employee KPI Responses
                          </div>

                          {kpis.length === 0 ? (
                            <div className="ar-muted12">
                              No KPI responses available.
                            </div>
                          ) : (
                            kpis.map((kpi, kpiIndex) => (
                              <div
                                key={getKpiId(kpi) ?? kpiIndex}
                                className="og-kpi-item"
                              >
                                <div className="og-kpi-dot ar-kpi-dot" />

                                <div className="ar-flex1">
                                  <div className="ar-kpi-title">
                                      <div className="d-flex align-items-center justify-content-between">
                                        
                                             <span> {getKpiTitle(kpi)}</span>
                                     <div>         
                                     <b>Completion(%):</b>
                                    <span className="ar-kpi-pct">
                                      {getKpiProgress(kpi)}%
                                    </span>
                                    </div>
                                      
                                    
                                  </div>
                                  </div>

                                  <div
                                    style={{
                                      height: 5,
                                      background: "#e2e8f0",
                                      borderRadius: 6,
                                      overflow: "hidden",
                                      margin: "3px 0",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: `${Math.min(
                                          100,
                                          Math.max(0, getKpiProgress(kpi)),
                                        )}%`,
                                        height: "100%",
                                        background: "#38a169",
                                        borderRadius: 6,
                                      }}
                                    />
                                  </div>

                                  <div className="ar-kpi-narr">
                                    {getKpiNarrative(kpi) ||
                                      "No employee update provided."}
                                      </div>

                                  {kpi?.targetDate && (
                                    <div className="ar-muted12">
                                      Target date: {formatDate(kpi.targetDate)}
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))
                          )}
                        </div>

                        {/* KRA RATING */}

                        {/* KRA RATING */}

                        {(() => {
                          const key = String(kraId);
                          const selectedRating = ratings[key] || 0;
                          const isSaving = savingKraId === Number(kraId);

                          return (
                            <div
                              className={`ar-rate-box ${
                                selectedRating ? "ar-rated" : ""
                              }`}
                            >
                              <div className="ar-rate-title">
                                <i className="fa fa-star"></i> Your Rating for{" "}
                                {getKraTitle(kra)} (1–5) *
                              </div>
                              <div className="ar-q-score-row">
                              <div className="ar-rate-btns">
                                {[1, 2, 3, 4, 5].map((n) =>
                                  ratingButton(key, n, "kra", selectedRating),
                                )}

                                {/* <span className="ar-rate-current">
                                  Currently: {selectedRating} selected
                                </span> */}
                              </div>

                              <div className="ar-flex1">
                                <label className="og-label">
                                  Your Comment for this KRA
                                </label>

                                <textarea
                                  className="og-textarea ar-ta-60"
                                  placeholder="Enter your assessment comment..."
                                  value={kraComments[key] || ""}
                                  disabled={isEmployeeView || isSaving}
                                  onChange={(e) =>
                                    setKraComments((prev) => ({
                                      ...prev,
                                      [key]: e.target.value,
                                    }))
                                  }
                                />
                              </div>
                              </div>
                              {/* {!isEmployeeView && (
        <button
          type="button"
          className="btn-og btn-og-primary btn-og-sm"
          style={{ marginTop: 10 }}
          disabled={isSaving || submitting}
          onClick={() => handleSaveKraScore(kra)}
        >
          {isSaving ? "Saving..." : "Save KRA Score"}
        </button>
      )} */}
                            </div>
                          );
                        })()}
                      </div>
                    );
                  })
                )}
              </div>

              {/* =================================================
                  OPEN FORM QUESTIONS
              ================================================= */}

              <div className="og-card ar-mb14">
                <div className="og-section-hd">
                  <div className="og-section-num">B</div>

                  <div className="og-section-title">
                    Current Cycle Evaluation
                  </div>

                  <div className="og-section-wt">
                    {criteriaWeight}% of final score
                  </div>
                </div>

                {questionList.length === 0 ? (
                  <div className="ar-empty-q">
                    No current cycle evaluation available.
                  </div>
                ) : (
                  questionList.map((question, index) => {
                    const questionId = getQuestionId(question, index);

                    return (
                      <div
                        key={questionId}
                        className={`ar-q-item ${
                          index === questionList.length - 1
                            ? "ar-q-item-last"
                            : ""
                        }`}
                      >
                        <div className="ar-q-meta">
                          <span className="ar-q-cat">
                            {getQuestionCategory(question)}
                          </span>

                          <span className="ar-q-wt">
                            {getQuestionWeight(question)}%
                          </span>
                        </div>

                        <div className="ar-q-text">
                          {getQuestionText(question)}
                        </div>

                        {/* EMPLOYEE ANSWER */}

                        <div className="ar-q-answer">
                          <div className="ar-q-answer-label">Employee:</div>
                          <p style={{ whiteSpace: "pre-wrap" }}>
                            {" "}
                            {getEmployeeAnswer(question)}
                          </p>
                        </div>

                        {question?.SkipLevelComment && (
                          <div
                            style={{
                              background: "#f0fff4",
                              border: "1px solid #c6f6d5",
                              borderRadius: 8,
                              padding: "10px 12px",
                              marginBottom: 10,
                            }}
                          >
                            <div
                              style={{
                                fontSize: 11,
                                fontWeight: 700,
                                color: "#276749",
                                marginBottom: 6,
                              }}
                            >
                              <i className="fa fa-user-check"></i> Skip-level
                              Comment:{" "}
                            </div>

                            {getSkipLevelAnswer(question) && (
                              <p
                                style={{
                                  fontSize: 12,
                                  color: "#276749",
                                  fontStyle: "italic",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                getSkipLevelAnswer(question)
                              </p>
                            )}
                          </div>
                        )}

                        {/* SCORE + ASSESSMENT */}

                        <div className="ar-q-score-row">
                          <div>
                            <label className="og-label">
                              Your Score (1–5) *
                            </label>

                            <div className="ar-q-btns">
                              {[1, 2, 3, 4, 5].map((n) =>
                                ratingButton(
                                  questionId,
                                  n,
                                  "question",
                                  questionScores[questionId] || 0,
                                ),
                              )}
                            </div>
                          </div>

                          <div className="ar-flex1">
                            <label className="og-label">Your Assessment</label>

                            <textarea
                              className="og-textarea ar-ta-48"
                              value={
                                questionComments[questionId] ||
                                getManagerAnswer(question) ||
                                ""
                              }
                              onChange={(e) =>
                                setQuestionComments((prev) => ({
                                  ...prev,
                                  [questionId]: e.target.value,
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              {/* =================================================
                  COMPUTED SCORE
              ================================================= */}

              <div className="og-computed-score ar-mb14">
                <div>
                  <div className="og-cs-label">Weighted Computed Score</div>

                  <div className="og-cs-value">
                    {Number(computedScore).toFixed(2)}{" "}
                    <span className="ar-cs-outof">/ 5.00</span>
                  </div>

                  <div className="ar-cs-formula">
                    KRA {Number(kraScore || 0).toFixed(2)}×{kraWeight}% + Open
                    Form {Number(criteriaScore || 0).toFixed(2)}×
                    {criteriaWeight}%
                  </div>
                </div>

                <div className="ar-cs-right">
                  <div className="og-cs-label">Rating Label</div>

                  <div className="ar-cs-note">Set by HR at Normalization</div>
                </div>
              </div>

              {/* =================================================
                  PROMOTION
              ================================================= */}

              <div
                className="og-card ar-promo"
                title="Promotion recommendation is set at Skip-Level stage"
              >
                <div className="ar-promo-row">
                  <div className="ar-promo-icon">
                    <i className="fa fa-arrow-trend-up ar-muted-color"></i>
                  </div>

                  <div>
                    <div className="ar-promo-title">
                      Promotion Recommendation
                    </div>

                    <div className="ar-muted12">
                      {promotionRecommended ? "Recommended" : "Not Recommended"}
                    </div>
                  </div>

                  <i className="fa fa-lock ar-promo-lock"></i>
                </div>
              </div>

              {/* =================================================
                  OVERALL COMMENT
              ================================================= */}

              {/* <div className="og-card">
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 700,
                    color: "#1a1a2e",
                    marginBottom: 10,
                  }}
                >
                  Overall Review Comment
                </div>
 
                <textarea
                  className="og-textarea"
                  value={overallComment}
                  onChange={(e) => setOverallComment(e.target.value)}
                  style={{
                    minHeight: 100,
                  }}
                />
              </div> */}
            </div>

            {/* =====================================================
                RIGHT SIDEBAR
            ===================================================== */}

            <div>
              {/* REVIEW PROGRESS */}

              <div className="og-card ar-mb12">
                <div className="ar-side-title">Review Progress</div>

                <div className="ar-mb8">
                  <div className="ar-prog-row">
                    <span>KRAs Rated</span>

                    <span className="ar-fw600">
                      {kraRatedCount}/{kraList.length}
                    </span>
                  </div>

                  <div className="og-progress">
                    <div
                      className="og-progress-bar ar-bar-green"
                      style={{
                        width: `${kraProgress}%`,
                      }}
                    ></div>
                  </div>
                </div>

                <div>
                  <div className="ar-prog-row">
                    <span>Questions Scored</span>

                    <span className="ar-fw600">
                      {questionScoredCount}/{questionList.length}
                    </span>
                  </div>

                  <div className="og-progress">
                    <div
                      className="og-progress-bar"
                      style={{
                        width: `${questionProgress}%`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>

              {/* TIMELINE */}

              <div className="og-card ar-mb12">
                <div className="ar-side-title">Timeline</div>

                <div className="ar-tl-list">
                  {timeline.length === 0 ? (
                    <div className="ar-muted-color">
                      No timeline data available.
                    </div>
                  ) : (
                    timeline.map((item, index) => {
                      const status = String(
                        item?.Status || item?.status || "",
                      ).toLowerCase();

                      const completed =
                        status === "completed" ||
                        status === "complete" ||
                        item?.IsCompleted === true;

                      const current =
                        status === "current" ||
                        status === "inprogress" ||
                        item?.IsCurrent === true;

                      return (
                        <div
                          key={item?.Id ?? index}
                          className={`ar-tl-item ${
                            completed || current ? "ar-tl-active" : ""
                          }`}
                        >
                          <i
                            className={`${
                              completed
                                ? "fa fa-circle-check"
                                : current
                                  ? "fa fa-clock"
                                  : "fa fa-circle"
                            } ar-tl-icon ${
                              completed
                                ? "ar-tl-done"
                                : current
                                  ? "ar-tl-current"
                                  : ""
                            }`}
                          ></i>

                          <span className={current ? "ar-tl-text-current" : ""}>
                            {item?.Title || item?.Name || "-"} —{" "}
                            {formatDate(item?.Date || item?.DueDate)}
                          </span>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>

              {/* AUDIT TRAIL */}

              <div className="og-card">
                <div className="ar-side-title">
                  <i className="fa fa-clock-rotate-left"></i> Audit Trail
                  <span className="ar-audit-sub">
                    Visible to reviewers only
                  </span>
                </div>

                <div className="ar-audit-list">
                  {auditTrail.length === 0 ? (
                    <div className="ar-muted12">
                      No audit records available.
                    </div>
                  ) : (
                    auditTrail.map((item, index) => (
                      <div key={item?.Id ?? index} className="ar-audit-item">
                        <div className="ar-audit-action">
                          {item?.Action || item?.Title || item?.Event || "-"}
                        </div>

                        <div className="ar-audit-meta">
                          {item?.UserName ||
                            item?.ActorName ||
                            reviewerName ||
                            "-"}{" "}
                          · {formatDateTime(item?.CreatedAt || item?.Date)}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* =====================================================
              SEND BACK MODAL
          ===================================================== */}

          {showSendBackModal && (
            <div
              className={`og-modal-overlay ${showSendBackModal ? "open" : ""}`}
            >
              <div className="og-modal">
                <div className="og-modal-header">
                  <div className="og-modal-title">
                    <i className="fa fa-rotate-left ar-red"></i> Send Back to
                    Employee
                  </div>

                  <button
                    type="button"
                    className="og-modal-close"
                    onClick={() => setShowSendBackModal(false)}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="og-form-group">
                    <label className="og-label">Send Back To *</label>

                    <select className="og-select">
                      <option>Employee (Self Assessment)</option>
                    </select>
                  </div>

                  <div className="og-form-group ar-mb0">
                    <label className="og-label">Reason *</label>

                    <textarea
                      className="og-textarea"
                      placeholder="Clearly explain what needs to be corrected..."
                      value={sendBackReason}
                      onChange={(e) => setSendBackReason(e.target.value)}
                    ></textarea>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn-og btn-og-secondary"
                    onClick={() => setShowSendBackModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn-og btn-og-danger"
                    onClick={handleSendBack}
                  >
                    <i className="fa fa-rotate-left"></i> Send Back
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* =====================================================
              SUBMIT MODAL
          ===================================================== */}

          {showSubmitModal && (
            <div
              className={`og-modal-overlay ${showSubmitModal ? "open" : ""}`}
            >
              <div className="og-modal">
                <div className="og-modal-header">
                  <div className="og-modal-title">
                    <i className="fa fa-check-circle ar-green"></i> Submit
                    Manager Review
                  </div>

                  <button
                    type="button"
                    className="og-modal-close"
                    onClick={() => setShowSubmitModal(false)}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="ar-submit-center">
                    <div className="ar-submit-emoji">✅</div>

                    <div className="ar-submit-title">
                      Submit review for {employeeName}?
                    </div>

                    <div className="ar-submit-sub">
                      Moves to Skip-Level review after submission.
                    </div>

                    <div className="ar-submit-score">
                      Computed Score:{" "}
                      <strong>{Number(computedScore).toFixed(2)} / 5.00</strong>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn-og btn-og-secondary"
                    onClick={() => setShowSubmitModal(false)}
                  >
                    Cancel
                  </button>

                  {/* <button
                    type="button"
                    className="btn-og btn-og-primary"
                    onClick={handleSubmitReview}
                  >
                    <i className="fa fa-check"></i> Submit Review
                  </button> */}

                  <button
                    type="button"
                    className="btn-og btn-og-primary"
                    onClick={handleManagerSubmit}
                    disabled={submitting}
                  >
                    Submit Review
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default AssessmentReview;
